import { alertRequest, body, request } from "services/request";

const resource = "api/dev/organization";

const getOdometerHistoryItems = (organizationId: number) =>
    request(`${resource}/getOdometerHistoryItems/${organizationId}?$orderby=id desc`, { method: "GET" });
const updateOdometerHistoryItem = (params: {}) => alertRequest(`${resource}/updateOdometerHistoryItem`, body(params));
const deleteOdometerHistoryItem = (params: {}) => alertRequest(`${resource}/deleteOdometerHistoryItem`, body(params));

export { getOdometerHistoryItems, updateOdometerHistoryItem, deleteOdometerHistoryItem };
